import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { catchError, finalize, map } from 'rxjs/operators';
import { IApiResponse } from '~global-interfaces/IApiResponse';
import { IResearchPodcastPopulated } from '~global-interfaces/IResearchPodcast';

import { alsterAPI_URL } from '~api/api-urls';
import { ErrorHandlingService } from '~shared/services/error-handling.service';
import { LoadingIndicatorService } from '~shared/services/loading-indicator.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalPodcastPlayerService {
  currentPodcast: WritableSignal<IResearchPodcastPopulated | null> = signal(null);
  showPlayer: WritableSignal<boolean> = signal(false);
  isLoading: WritableSignal<boolean> = signal(false);
  http = inject(HttpClient);
  errorHandlingService = inject(ErrorHandlingService);
  loadingIndicatorService = inject(LoadingIndicatorService);

  playPodcast(companyTicker: string, research_Date: string, research_language = 'en') {
    this.fetchPodcast(companyTicker, research_Date, research_language);
  }

  stopPodcast() {
    this.currentPodcast.set(null);
    this.showPlayer.set(false);
  }

  hidePlayer() {
    this.showPlayer.set(false);
  }

  showGlobalPlayer() {
    if (this.currentPodcast()) {
      this.showPlayer.set(true);
    }
  }

  fetchPodcast(companyTicker: string, reserach_date: string, research_language: string) {
    this.isLoading.set(true);
    this.http
      .get<IApiResponse<IResearchPodcastPopulated>>(
        `${alsterAPI_URL}research-podcast/find/${companyTicker}/${reserach_date}/${research_language}`
      )
      .pipe(
        map((response) => response.data[0]),

        catchError((error) => this.errorHandlingService.handleError(error, 'fetch research podcast')),
        finalize(() => {
          this.isLoading.set(false);
          this.showGlobalPlayer();
        })
      )
      .subscribe({
        next: (podcast: IResearchPodcastPopulated) => {
          this.currentPodcast.set(podcast);
          this.loadingIndicatorService.setLastRequestMessage('fetch research podcast success');
          this.loadingIndicatorService.setLastRequestSuccess(true);
        },
        error: (error) => this.errorHandlingService.handleRequestError(error),
      });
  }
}
